"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Save_exports = {};
__export(Save_exports, {
  default: () => Save_default
});
module.exports = __toCommonJS(Save_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.0117 10.2891L9.09375 11.207C9.0026 11.2982 8.88542 11.3438 8.74219 11.3438C8.59896 11.3438 8.48177 11.2982 8.39062 11.207C8.28646 11.1029 8.23438 10.9857 8.23438 10.8555C8.23438 10.7122 8.28646 10.5951 8.39062 10.5039L10.0898 8.80469C10.207 8.6875 10.3438 8.62891 10.5 8.62891C10.6562 8.62891 10.793 8.6875 10.9102 8.80469L12.6289 10.5039C12.7201 10.6081 12.7656 10.7318 12.7656 10.875C12.7656 11.0052 12.7201 11.1159 12.6289 11.207C12.5247 11.3112 12.401 11.3633 12.2578 11.3633C12.1276 11.3633 12.0104 11.3112 11.9062 11.207L11.0078 10.3086V16.3242C11.0078 16.4674 10.9557 16.5911 10.8516 16.6953C10.7604 16.7865 10.6432 16.832 10.5 16.832C10.3698 16.832 10.2526 16.7865 10.1484 16.6953C10.0573 16.5911 10.0117 16.4674 10.0117 16.3242V10.2891ZM3.99609 10.25C3.99609 9.70312 4.19141 9.23438 4.58203 8.84375C4.97266 8.45312 5.44792 8.25781 6.00781 8.25781C6.17708 8.25781 6.33984 8.27734 6.49609 8.31641C6.65234 8.35547 6.79557 8.40755 6.92578 8.47266C7.05599 8.53776 7.1862 8.55078 7.31641 8.51172C7.44661 8.47266 7.54427 8.39453 7.60938 8.27734C7.67448 8.14714 7.6875 8.01693 7.64844 7.88672C7.60938 7.75651 7.52474 7.65885 7.39453 7.59375C7.31641 7.55469 7.22526 7.51562 7.12109 7.47656C7.02995 7.4375 6.9388 7.40495 6.84766 7.37891C6.83464 7.33984 6.82812 7.30729 6.82812 7.28125C6.82812 7.24219 6.82812 7.20312 6.82812 7.16406C6.82812 6.31771 7.14062 5.59505 7.76562 4.99609C8.40365 4.38411 9.17839 4.07812 10.0898 4.07812C10.9883 4.07812 11.75 4.38411 12.375 4.99609C13.013 5.59505 13.332 6.31771 13.332 7.16406C13.332 7.25521 13.3255 7.33984 13.3125 7.41797C13.3125 7.49609 13.306 7.58073 13.293 7.67188C13.2799 7.76302 13.293 7.85417 13.332 7.94531C13.3711 8.03646 13.4297 8.10807 13.5078 8.16016C13.5859 8.22526 13.6706 8.26432 13.7617 8.27734C13.8659 8.29036 13.9701 8.27734 14.0742 8.23828C14.2044 8.16016 14.3477 8.10156 14.5039 8.0625C14.6602 8.02344 14.8229 8.00391 14.9922 8.00391C15.5521 8.00391 16.0273 8.19922 16.418 8.58984C16.8086 8.98047 17.0039 9.44922 17.0039 9.99609C17.0039 10.556 16.8086 11.0312 16.418 11.4219C16.0273 11.8125 15.5521 12.0078 14.9922 12.0078C14.862 12.0078 14.7448 12.0599 14.6406 12.1641C14.5495 12.2552 14.5039 12.3659 14.5039 12.4961C14.5039 12.6393 14.5495 12.763 14.6406 12.8672C14.7448 12.9583 14.862 13.0039 14.9922 13.0039C15.8255 13.0039 16.5352 12.7109 17.1211 12.125C17.707 11.5391 18 10.8294 18 9.99609C18 9.17578 17.707 8.47266 17.1211 7.88672C16.5352 7.30078 15.8255 7.00781 14.9922 7.00781C14.888 7.00781 14.7773 7.01432 14.6602 7.02734C14.543 7.04036 14.4323 7.05339 14.3281 7.06641C14.3151 6.51953 14.1979 5.9987 13.9766 5.50391C13.7422 5.02214 13.4297 4.60547 13.0391 4.25391C12.6615 3.88932 12.2188 3.60286 11.7109 3.39453C11.2031 3.1862 10.6628 3.08203 10.0898 3.08203C9.50391 3.08203 8.95052 3.1862 8.42969 3.39453C7.92188 3.61589 7.47266 3.90885 7.08203 4.27344C6.70443 4.63802 6.39844 5.06771 6.16406 5.5625C5.94271 6.05729 5.83203 6.59115 5.83203 7.16406C5.83203 7.17708 5.83203 7.1901 5.83203 7.20312C5.83203 7.21615 5.83203 7.23568 5.83203 7.26172C5.03776 7.30078 4.36719 7.61328 3.82031 8.19922C3.27344 8.77214 3 9.45573 3 10.25C3 11.0833 3.29297 11.793 3.87891 12.3789C4.46484 12.9648 5.17448 13.2578 6.00781 13.2578C6.13802 13.2578 6.2487 13.2122 6.33984 13.1211C6.44401 13.0169 6.49609 12.8932 6.49609 12.75C6.49609 12.6068 6.44401 12.4896 6.33984 12.3984C6.2487 12.2943 6.13802 12.2422 6.00781 12.2422C5.44792 12.2422 4.97266 12.0469 4.58203 11.6562C4.19141 11.2656 3.99609 10.7969 3.99609 10.25Z",
      fill: "currentColor"
    }
  )
);
const SvgSave = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Save_default = SvgSave;
